module.exports = __webpack_public_path__ + "img/e1c143cbdf359b2bd5265d9ca7428d1e.png";